import './Header.scss'
import * as React from 'react'
import RootStore from '../../stores/RootStore'
import { observer } from 'mobx-react'
import logo from '../../media/images/tfo-logo.svg'
import { useIntl } from 'react-intl'
import { hooks, utils, Elements } from '@tfo/common'
import LanguageSelector from './LanguageSelector'

const { Image, Heading7 } = Elements
const Header = observer(() => {
	const store = hooks.useStore<RootStore>()
	const intl = useIntl()

	return (
		<header className="Header">
			<Image
				className="Header__Logo"
				src={logo}
			/>

			{store.userStore.name !== '' &&
				<div className="Header__Username">
					<Heading7>{intl.formatMessage({ id: `common.menu` })}</Heading7>

					<div className="HeaderListGroup">
						<button
							className="HeaderListButton"
							onClick={() => store.individualViewStore.onShowHeaderMenu()}
						/>

						{store.individualViewStore.showHeaderMenu && (
							<ul className="HeaderList">
								<li
									onClick={() => {
										utils.setCookie('')
										window.location.href = '/login'
									}}>
									{intl.formatMessage({ id: `common.logout` })}
								</li>
							</ul>
						)}
					</div>
				</div>}
		</header>
	)
})

export default Header
